.ps_titulo<template lang="pug">
v-app
  section
    .d-flex.row.flex-row.align-items-end
      .col-12
        h2.ps_titulo
          i Objetivos
    .d-flex.row.flex-row.align-items-start
      .col-5
        .card.ad_border1-secondary.rounded-xl
          .card-body
            .form-group.row.align-items-center
              .col-auto.pl-0.pr-2
                i.icon-letters.icon-letters__producto.mr-1 R
              .col.px-0.ad_select
                select(v-model="selectedRole", @change='getSelectedTriplets($event)')
                  option(:value="null" disabled) Selecciona Rol
                  option(:value="role", v-for="role in userRoles", :key="role._id") {{role.name}}
              .d-flex.col-auto.pr-0.d-flex.align-self-stretch
                .input-refresh.d-flex.flex-row.ml-2
                  label.pl-0.m-0 Libre
                  input.form-checkbox.text-none(type="checkbox", id="open", label="", :value="open" v-model="openSelected", @change='getSelectedTriplets($event)',:disabled='!selectedRole')
            .form-group.row.align-items-center
              .col-auto.pl-0.pr-2
                i.icon-letters.icon-letters__viaje.mr-1 V
              .col.px-0.ad_select.disabled
                select(v-model='selectedViaje', disabled)
                  option(:value="null" disabled) Selecciona viaje
                  option(:value="travel", v-for="travel in travels", :key="travel._id") {{travel.name}}
            .form-group.row.align-items-center
              .col-auto.pl-0.pr-2
                i.icon-letters.icon-letters__segmento.mr-1 S
              .col.px-0.ad_select.disabled
                select(v-model="selectedSegmento", disabled)
                  option(:value="null" disabled) Selecciona segmento
                  option(:value="segment", v-for="segment in segments", :key="segment._id") {{segment.name}}
            .form-group.row.align-items-center
              .col-auto.pl-0.pr-2
                i.icon-letters.icon-letters__producto.mr-1 P
              .col.px-0.ad_select.disabled
                select(v-model="selectedProducto", disabled)
                  option(:value="null" disabled) Selecciona Producto
                  option(:value="product", v-for="product in products", :key="product._id") {{product.name}}            
            .form-group.row.align-items-center
              .col-auto.pl-0.pr-2
                i.icon-letters.icon-letters__negocio.mr-1 N
              .d-flex.col.p-0
                .ad_select(:class='{disabled : !selectedProducto && !openSelected}')
                  select(v-model='selectedKpiNegocio', :disabled='!selectedProducto && !openSelected', @change='setPorcentage($event)')
                    option(:value="null" disabled) Selecciona KPI Negocio
                    option(:value="business" v-for="business in businesstypes" :key="business._id") {{business.name}}
            .form-group.row.align-items-center
              .col-auto.pl-0.pr-2
                i.icon-letters.icon-letters__kpi.mr-1 A
              .d-flex.col.p-0
                .ad_select(:class='{disabled : !selectedKpiNegocio && !openSelected}')
                  select(v-model='selectedKpiAdherencia' :disabled='!selectedKpiNegocio && !openSelected')
                    option(:value="null" disabled) Selecciona KPI Adherencia
                    option(:value="kpi" v-for="kpi in kpis" :key="kpi._id") {{kpi.name}}
              .d-flex.col-auto.pr-0.d-flex.align-self-stretch
                .d-flex.ad_text-grayMedio.text-center.w-100
                  .input-refresh.d-flex.flex-row.align-items-center.ml-2(:class='{disabled : !selectedKpiNegocio && !openSelected}')
                    input(type="text" value="" v-model="registroAdherencia" maxlength="3" :disabled='!selectedKpiNegocio && !openSelected')
                    | %
                    a#kpiadherencia(href="#")
                      i.fas.fa-info-circle.ad_text-secondary.ml-1
                    b-tooltip(target="kpiadherencia" , placement='top')
                      | % de cumplimiento del KPI de Adherencia que se espera alcanzar en la semana      
            .form-group.row(v-if="user.profile.leader_leaders")
              multiselect.w-100(
                v-model="users",
                :options="team",                
                :multiple="true",
                :close-on-select="true",
                :clear-on-select="false",
                :preserve-search="true",
                placeholder="Seleccione Líder",
                label="name",
                track-by="_id",
                :class='{disabled: !selectedKpiAdherencia && !openSelected}'
              )
            .form-group.row
              .w-100(v-if="openSelected")
                v-menu(ref='menu', v-model='menu', :close-on-content-click='true', :nudge-right='40', lazy, transition='scale-transition', offset-y, full-width, min-width='290px', content-class='date-picker')
                  v-text-field.date-input.pt-0.mt-0(slot='activator', v-model='date_opobj', label='', placeholder='Fecha', append-icon='fas fa-calendar-alt')
                  v-date-picker(v-model='date_opobj', no-title, locale="es", :min="startWeek", @input="menu2 = false", next-icon='fas fa-chevron-right', prev-icon='fas fa-chevron-left', :first-day-of-week="1")     
            .form-group.row.align-items-center
              .col-auto.pl-0.pr-1
                i.icono.icono-comentarios.ad_text-primary
              .col.px-0
                textarea.form-control(id='comm', placeholder='Comentarios (opcional)', rows='3', v-model="comment")
            .row
              .col.d-flex.justify-content-end
                button.btn.btn-secondary.btn__large(:class='{disabled : !selectedKpiAdherencia && !openSelected}' @click="create()")
                  | Crear Objetivo
                  i.fas.fa-plus.border.border-white.rounded-circle.p-1.ml-2

      .col-7
        .card.ad_border1-secondary.rounded-xl
          h4.ad_text-primary
            i Continuados          
          .col-12.text-center.rounded-lg.ad_bg-gray.pt-3(v-show='continuedObjectives.length == 0')
            p.muted no hay objetivos continuados
          div(v-if="continuedObjectives.length > 0")
            .col-12.py-2.rounded-lg.ad_bg-gray.mb-3(v-for="(co, index) in continuedObjectives")
              form
                .d-flex.row.form-group.align-items-end.mb-1
                  .col.pr-0
                    a.group-kpi(:id="'viaje' + index")
                      i.icon-letters.icon-letters__viaje.mr-1(v-if="co._id.travel.length > 0") V
                      i.icon-letters.icon-letters__producto.mr-1(v-if="co._id.product.length > 0") P
                      i.icon-letters.icon-letters__segmento.mr-1(v-if="co._id.segment.length > 0") S
                    b-tooltip(:target="'viaje' + index" , placement='top')
                      | {{co._id.travel.length > 0 ? co._id.travel[0].name : ""}} + {{co._id.product.length > 0 ? co._id.product[0].name : ""}} + {{co._id.segment.length > 0 ? co._id.segment[0].name : ""}}
                    label.ml-1
                      i.icon-letters.icon-letters__negocio.mr-1 N
                      | {{co._id.business_type.length > 0 ? co._id.business_type[0].name: ''}}
                  .col-auto
                    p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
                      sup Registro
                      span {{co.objectives[0].businesspercentage}}%
                    p.d-inline-block.mb-0.ad_text-grayMedio
                      sup Meta
                      span {{co._id.business_type.length > 0 ? co._id.business_type[0].goal : ''}}%
              .d-flex.row
                .col-12
                  table.w-100.text-center.table-rounded-body
                    thead
                      tr
                        th
                        th.text-left Objetivo
                        th
                        th 
                        th Registro
                        th Meta
                        th
                    tbody
                      tr(v-for="(currentco, n) in co.objectives" :key="currentco._id")                        
                        td
                          div.pr-0
                            span.num_circle.ad_bg-secondary {{n + 1}}
                        td.text-left
                          div.pl-2
                            | {{currentco.kpi.length > 0 ? currentco.kpi[0].name : 'Sin Kpi'}}
                        td
                          div.px-0
                            span.ad_text-success.text-nowrap
                              | {{currentco.date | WeekDuration}}&deg; sem
                        td
                          div.px-0.justify-content-center.text-info
                            | {{currentco.open ? "Libre" : ""}}
                        td
                          div.px-0.justify-content-center
                            | {{currentco.kpipercentage}}%
                        td
                          div.px-0.justify-content-center
                            | {{currentco.kpi.length > 0 ? currentco.kpi[0].goal : ''}}%
                        td
                          div.px-0
                            a(href="#" :id="'userc-' + n")
                              i.far.fa-user-circle.ad_text-primary
                            b-tooltip(:target="'userc-' + n" , placement='top')
                              span(v-for="(u, index) in currentco.user")
                                | {{u.name}}
                                span(v-if="index != (currentco.user.length-1)") ,
                        td
                          div.px-0
                            a.no-decoration(href="#" title="Comentarios" @click.stop='openObjDetail(currentco._id)')
                              i.icono.icono-comentarios.ad_text-primary
                        td
                          div.pl-0.justify-content-end
                            button.btn.btn-secondary.px-3(@click="openUpdateModal(currentco)")        
                              | Cerrar 
                            b-tooltip(:target="'cerrar' + index" , placement='top')
                              | Cerrar objetivo
                   
          h4.mt-4.ad_text-primary
            i Nuevos
          .col-12.text-center.rounded-lg.ad_bg-gray.pt-3(v-show='currentWeekObjectives.length == 0')
            p.muted Aún no ha seleccionado nuevos objetivos
          div(v-if="currentWeekObjectives.length > 0")
            .col-12.py-2.rounded-lg.ad_bg-gray.mb-3(v-for="(co , n) in currentWeekObjectives")
              form
                .d-flex.row.form-group.align-items-end.mb-1
                  .col.pr-0
                    a.group-kpi(:id="'viajenuevo' + n")
                      i.icon-letters.icon-letters__viaje.mr-1(v-if="co._id.travel.length > 0") V
                      i.icon-letters.icon-letters__producto.mr-1(v-if="co._id.product.length > 0") P
                      i.icon-letters.icon-letters__segmento.mr-1(v-if="co._id.segment.length > 0") S
                    b-tooltip(:target="'viajenuevo' + n" , placement='top')
                      | {{co._id.travel.length > 0 ? co._id.travel[0].name : ""}} + {{co._id.product.length > 0 ? co._id.product[0].name : ""}} + {{co._id.segment.length > 0 ? co._id.segment[0].name : ""}}
                  
                    label.ml-1
                      i.icon-letters.icon-letters__negocio.mr-1 N
                      | {{co._id.business_type.length > 0 ? co._id.business_type[0].name : ''}}
                  .col-auto
                    p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
                      sup Registro
                      span {{co.objectives[0].businesspercentage}}%
                    p.d-inline-block.mb-0.ad_text-grayMedio
                      sup Meta
                      span {{co._id.business_type.length > 0 ? co._id.business_type[0].goal: ''}}%
              .d-flex.row
                .col-12
                  table.w-100.text-center.table-rounded-body
                    thead
                      tr
                        th
                        th.text-left Objetivo
                        th
                        th 
                        th Registro
                        th Meta
                        th
                    tbody
                      tr(v-for="(currentwo, n) in co.objectives", :key="currentwo._id")
                        td
                          div.pr-0
                            span.num_circle.ad_bg-secondary {{n + 1}}
                        td.text-left
                          div.pl-2
                            | {{currentwo.kpi.length > 0 ? currentwo.kpi[0].name: 'Sin Kpi'}}
                        td
                          div.px-0
                            span.ad_text-success.text-nowrap
                              | {{currentwo.date | WeekDuration}}&deg; sem
                        td
                          div.px-0.justify-content-center.text-info
                            | {{currentwo.open ? "Libre" : ""}}
                        td
                          div.px-0.justify-content-center
                            | {{currentwo.kpipercentage}}%
                        td
                          div.px-0.justify-content-center
                            | {{currentwo.kpi.length > 0 ? `${currentwo.kpi[0].goal}%` : ''}}
                        td
                          div.px-0
                            a(href="#" :id="'user-' + n")
                              i.far.fa-user-circle.ad_text-primary
                            b-tooltip(:target="'user-' + n" , placement='top')
                              span(v-for="(u, index) in currentwo.user")
                                | {{u.name}}
                                span(v-if="index != (currentwo.user.length-1)") , 
                        td
                          div.px-0
                            a.no-decoration(href="#" title="Comentarios" @click.stop='openObjDetail(currentwo._id)')
                              i.icono.icono-comentarios.ad_text-primary
                        td
                          div.pl-0.justify-content-end
                            button.btn-icon.p-0.ad_text-danger.border-btnicon-danger.rounded-circle(@click="remove(currentwo._id)" :id="'eliminar' + n")
                              i.fas.fa-times.p-0
                            b-tooltip(:target="'eliminar' + n" , placement='top')
                              | Eliminar objetivo
          
          //- .col-12.text-center.mt-4.ad_bg-warningLight.rounded-lg.py-2
            //- p.ad_text-warningDark.m-0
              //- i.fas.fa-exclamation-triangle.mr-2
              //- i Tienes 2 Objetivos sin asignar a un Líder
  
  v-navigation-drawer(v-model='drawer2', app='', temporary='', right='', width='500')
    header.ad_bg-primary.pt-5.pb-2.px-4
      h3.text-white.mt-4
        i Comentarios
    section.py-4.px-2.overflowy-auto(v-if="objective")
      .col.d-flex.flex-nowrap
        label
          a.group-kpi(v-if="objective", id="comentviaje")
            i.icon-letters.icon-letters__viaje.mr-1(v-if="objective.travel") V
            i.icon-letters.icon-letters__producto.mr-1(v-if="objective.product") P
            i.icon-letters.icon-letters__segmento.mr-1(v-if="objective.segment") S
          b-tooltip(v-if="objective", target="comentviaje" , placement='top')
            | {{(objective.travel) ? objective.travel.name : ''}} + {{(objective.product) ? objective.product.name : ''}} + {{(objective.segment) ? objective.segment.name : ''}}
        label.ml-1
          p.icon-letters.icon-letters__negocio.mr-1 N
          | {{(objective.business_type) ? objective.business_type.name : ''}}
      .row.mt-3.align-items-end
        .col
          .col-12
            h4
              i.icon-letters.icon-letters__kpi.mr-1 A
              | {{(objective.kpi) ? objective.kpi.name : 'Sin Kpi'}}
        .col-auto.pr-5
          p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
            sup Registro
            span.ad_text-grayDark 60%
          p.d-inline-block.mb-0.ad_text-grayMedio
            sup Meta
            span 90%
      .col-12.mt-4
        .form-group.mt-4
          textarea.form-control(id="editcomm", placeholder='Agregar comentario', rows='3', v-model='commentObjective')
        .form-group.justify-content-between
          button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="drawer2 = false")
            i.far.fa-times-circle.fa-1x.mr-1.align-bottom
            | Cancelar
          button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="addCommentToObjective(objective._id)")
            | Agregar comentario
            i.fas.fa-chevron-right.fa-1x.ml-1.align-bottom
        
        hr.my-4
        
        h3.ad_text-grayMedio.mb-3
          i Anteriores
        div(v-if="objective")        
          .row.mb-3(v-for='comm in (objective.comments? objective.comments.slice().reverse(): [])')
            .col-4.pr-0
              p.font-weight-bold.m-0 {{comm.user}}
              small.d-block {{comm.date | DateFormat}}
              small.d-block {{comm.date | HourFormat}} hrs.
            .col-8.pl-0
              .dialog-box
                p {{comm.text}}
                div.px-0(v-if="moment(comm.date).week() == moment(plan.date).week()")
                  a.no-decoration(href="#" title="Editar" @click.stop='OpenEditCommObj(objective._id, comm._id, comm.text)')
                    i.icono.icon-pencil3.ad_text-primary

  v-navigation-drawer(v-model='drawer', app='', temporary='', right='', width='500')
    header.ad_bg-primary.pt-5.pb-2.px-4
      h3.text-white.mt-4
        i Cerrar objetivo
    section.py-4.px-2.overflowy-auto
      .col.d-flex.flex-nowrap
        p {{ currentObjective.kpi[0].name }}
      .d-flex.flex-row
        .col.d-flex.flex-nowrap
          a#provisioncerrar
            i.icon-letters.icon-letters__viaje.mr-1(v-if="currentObjective.travel.length > 0") V
            i.icon-letters.icon-letters__producto.mr-1(v-if="currentObjective.travel.length > 0") P
            i.icon-letters.icon-letters__segmento.mr-1(v-if="currentObjective.travel.length > 0") S
          b-tooltip(target="provisioncerrar" , placement='top')
            | {{ currentObjective.travel.length > 0 ? currentObjective.travel[0].name : ''}}-{{ currentObjective.segment.length ? currentObjective.segment[0].name : '' }}-{{currentObjective.product.length > 0 ? currentObjective.product[0].name : ''}}
          a#kpicerrar.ml-2
            i.icon-letters.icon-letters__kpi.mr-1 A
          b-tooltip(target="kpicerrar" , placement='top')
            | {{ currentObjective.kpi[0].name }}
          p KPI Adherencia
        .col-5
            c-form-radio.ad_radio.ad_radio-cumple(name="cumplimiento" v-model="cumplimiento" value="true" label="Cumple")
            c-form-radio.ad_radio.ad_radio-nocumple(name="cumplimiento" v-model="cumplimiento" value="false" label="No cumple")
      .col-12.mt-4
        .form-group.justify-content-between
          button.btn.btn-secondary-border.py-2.pl-2.pr-3.font-1em(@click="drawer = false")
            i.far.fa-times-circle.fa-1x.mr-1.align-bottom
            | Cancelar
          button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click='update()')
            | Cerrar compromisos
            i.fas.fa-chevron-right.fa-1x.ml-2.align-bottom
        
        hr.my-4
        
        h3.ad_text-grayMedio.mb-3
          i Comentarios
        div 
          .row.mb-3(v-for='comment in (currentObjective.comments? currentObjective.comments.slice().reverse(): [])')
            .col-4.pr-0
              p.font-weight-bold.m-0 {{ comment.user }}
              small.d-block {{ moment(comment.creation_date).utc().format("DD/MM/YYYY") }}
              small.d-block {{ moment(comment.creation_date).utc().format('LT') }}
            .col-8.pl-0
              .dialog-box
                p {{ comment.text }}
  b-modal(:id='editCommModal.id', centered, modal-class='modal-popUp', title-tag='div',header-class='d-flex', footer-class='d-flex flex-row flex-wrap')
    <template v-slot:modal-title>
      h3.font-weight-bold.mb-0 {{editCommModal.title}}
    </template>
    textarea.form-control(placeholder='Agregar comentario', rows='3', v-model='commentObjectiveEdit')
    <template v-slot:modal-footer="{ ok, cancel, hide }">
      .col-12.d-flex.justify-content-around
          b-button.px-4(size="lg", variant="danger", @click="closeCommentUpdate()")
            | Cancelar
          b-button.px-4(size="lg", variant="success", @click="editCommentObjective()")
            | Editar
    </template>       
</template>

<script>
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import Flatpickr from 'vendors/cover/vendors/flatpickr'
import { mapActions } from 'vuex'

export default {
  name: 'PSObjetivosGe',
  props: ['clickedNext', 'currentStep'],
  components: {
     Multiselect,
     Flatpickr
  },
  data() {
      return {
        registroICA: 60,
        selectedViaje: null,
        selectedSegmento: null,
        selectedProducto: null,
        selectedKpiNegocio: null,
        selectedKpiAdherencia: null,
        selectedLider: null,
        selectedRole: null,
        registroNegocio: 0,
        registroAdherencia: 0,
        currentObjective: {travel: [{name: ''}], segment: [{name: ''}], product: [{name: ''}], kpi: [{name:''}]},
        comment: '',
        commentObjective: '',
        commentObjectiveEdit: '',
        segments: [],
        travels: [],
        products: [],
        businesstypes: [],
        kpis: [],
        team: [],
        users: [],
        objective: null,
        lastWeekObjectives: [],
        currentWeekObjectives: [],
        continuedObjectives: [],
        maxObjectives: 4,
        user: null,
        userRoles: [],
        comment: null,
        plan: null,
        drawer: null,
        drawer3: null,
        drawer2: false,
        overlay: false,
        moveobjetivo: false,
        cumplimiento: '',
        date: null, 
        compromiso: true,
        problemas: true,
        otros: true,
        team_segments: [],
        team_products: [],
        canAddMore: true,
        open: false,
        openSelected: false,
        editCommModal: {
          id: 'edit-comment',
          title: 'Editar',
          comm_text: '',
          objective_id: null,
          comment_id: null
        },
        date_opobj: null,
        startWeek: moment().utc().startOf('isoWeek').subtract(1, "days").toISOString()
      }
  },
  methods: {
    ...mapActions('objective', [
      'createObjective',
      'getObjectiveByPlan', 
      'addComment', 
      'commentsById', 
      'getObjectiveById', 
      'close', 
      'getContObjByPlan', 
      'updateObjective',
      'updateBusiness',
      'deleteObjective',
      'updateObjectComment'
    ]),
    ...mapActions('travel', [
      'travelList'
    ]),
    ...mapActions('segment', [
      'ByTravelId', 'segmentSelectList'
    ]),
    ...mapActions('product', [
      'BySegmentId', 'productSelectList'
    ]),
    ...mapActions('businesstype', [
      'businessTypeByIds', 'businessBySegTraProd'
    ]),
    ...mapActions('kpi', [
      'kpiByIds', 'kpiBySegTraProRole'
    ]),
    ...mapActions('user', [
      'myTeam'    
    ]),
    ...mapActions('role', [
      'byTriplets', 'roleByIds'
    ]),
    moment,
    create() {
      const vm = this
      const { users, selectedViaje, selectedSegmento, selectedProducto, selectedKpiNegocio, selectedKpiAdherencia, registroNegocio, registroAdherencia } = vm
      let sumObjectives = 0
      if ( !vm.validateForm() ) {
         vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: "Necesita rellenar todos los campos antes de crear objetivo",
            closeable: true,
            duration: 5000
          })
      } else {
        const loading = vm.$toast.loading('Creando...')
        let comments = []
        if (vm.comment) {
          comments.push({
            user: vm.user.name,
            date: moment(),
            text: vm.comment
          })
        }
        if( isNaN(vm.registroAdherencia) || (vm.registroAdherencia > 100 || vm.registroAdherencia < -100)){
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'El KPI debe ser un numero entre 0 y 100',
            closeable: true,
            duration: 5000
          })
          return;
        }
        sumObjectives = vm._countObjectives()
        vm.canAddMore = (sumObjectives >= vm.maxObjectives) ? false: true;
        if (vm.canAddMore) {
          vm.createObjective({
            date: moment(),
            ica: vm.registroICA,
            travel: vm.selectedViaje,        
            segment: vm.selectedSegmento,
            product: vm.selectedProducto,
            business_type: vm.selectedKpiNegocio,
            kpi: vm.selectedKpiAdherencia,
            businesspercentage: vm.registroNegocio,
            kpipercentage: vm.registroAdherencia,
            user: vm.users,
            created_by: vm.user.id,
            comments: comments,
            plan: vm.plan,
            open: vm.openSelected,
            date_opobj: moment(vm.date_opobj)
          }).then((newObj) => {
            let done = false
            newObj.business_type = [newObj.business_type]
            newObj.kpi = [newObj.kpi]       
            for (let index in vm.continuedObjectives) {
              if (newObj.open) {
                if (vm.continuedObjectives[index]._id.business_type[0].name == newObj.business_type[0].name) {
                  vm._addNewObject(newObj, index)  
                  done = true
                  break
                }
              } else if (vm.continuedObjectives[index]._id.travel.length > 0) {
                if (vm.continuedObjectives[index]._id.travel[0].name == newObj.travel.name && vm.continuedObjectives[index]._id.product[0].name == newObj.product.name && vm.continuedObjectives[index]._id.segment[0].name == newObj.segment.name && vm.continuedObjectives[index]._id.business_type[0].name == newObj.business_type[0].name) {
                  vm._addNewObject(newObj, index)  
                  done = true
                  break
                }
              }      
            }
            done ? null : vm._addNewObject(newObj)    
            vm._clearForm()
            loading.hide()
            vm.$notify({
              type: 'success',
              title: 'Notificación',
              content: 'Objetivo creado',
              closeable: true,
              duration: 5000
            })
          }, (error) => {
            loading.hide()
            vm.$notify({
              type: 'danger',
              title: 'Notificación',
              content: error,
              closeable: true,
              duration: 5000
            })
          })
        } else {
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: `No puede tener mas de ${vm.maxObjectives} objetivos por planificación.`,
            closeable: true,
            duration: 5000
          })
        }
      }      
    },
    closeObjective(id) {
      const vm = this
      vm.close({id: id}).then(() => {
        for (let index in vm.currentWeekObjectives) {
          for (let indexo in vm.currentWeekObjectives[index].objectives) {
            if (vm.currentWeekObjectives[index].objectives[indexo]._id == id) {
              vm.currentWeekObjectives[index].objectives.splice(indexo, 1)
            }
          }
          if (vm.currentWeekObjectives[index].objectives.length == 0) {
            vm.currentWeekObjectives.splice(index, 1)
          }                  
        }        
        vm.$notify({
          type: 'success',
          title: 'Notificación',
          content: 'Objetivo cerrado',
          closeable: true,
          duration: 5000
        })
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    loadObjectivesByPlan() {
      const vm = this      
      vm.getObjectiveByPlan(vm.plan._id).then(() => {
        vm.objectives = vm.$store.getters['plan/getObjectives']
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      })
    },
    openUpdateModal(objectiveToClose) {
      const vm = this
      vm.drawer = true
      vm.currentObjective = objectiveToClose
    },
    update() {
      const vm = this
      const data = {
        id: vm.currentObjective._id,
        accomplished: vm.cumplimiento,
        state: true
      }
      if (vm.cumplimiento === '') {
        vm.$notify({
          type: 'danger',
          title: 'Notificacion',
          content: 'Debe elegir si objetivo se completo o no',
          closeable: true,
          duration: 5000
        })
      } else {
        vm.updateObjective(data).then(result => {
          for (let index in vm.continuedObjectives) {
            for (let indexo in vm.continuedObjectives[index].objectives) {
              if (vm.continuedObjectives[index].objectives[indexo]._id == data.id) {
                vm.continuedObjectives[index].objectives.splice(indexo, 1)
              }
            }
            if (vm.continuedObjectives[index].objectives.length == 0) {
              vm.continuedObjectives.splice(index, 1)
            }                  
          }
        vm.$notify({
          type: 'success',
          title: 'Notificación',
          content: 'Objetivo cerrado',
          closeable: true,
          duration: 5000
          })
        })
        vm.drawer = false
      }
    },
    commentsByObjective() {
      const vm = this
      vm.commentsById(id).then(() => {
        vm.comments = vm.$store.getters['commentsById/getComments']
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      })
    },
    addCommentToObjective(id) {
      const vm = this
      let comm = {
        user: vm.user.name,
        date: moment(),
        text: vm.commentObjective
      }
      vm.addComment({
        id: id,
        comment: comm  
      }).then(() => {
        vm.objective.comments.push(comm)
        vm.drawer2 = false        
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    getSegments($event) {
      const vm = this
      vm.selectedProducto = null
      vm.selectedKpiNegocio = null
      vm.selectedKpiAdherencia = null
      vm.registroNegocio = 0
      vm.registroAdherencia = 0
      const loading = vm.$toast.loading('Cargando segmentos...')
      vm.segmentSelectList().then(response => {
        vm.segments = vm.$store.getters['segment/getSegments']
        loading.hide()
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      })      
    },
    getProducts($event) {
      const vm = this
      vm.selectedKpiNegocio = null
      vm.registroNegocio = 0
      vm.registroAdherencia = 0
      vm.selectedKpiAdherencia = null
      const loading = vm.$toast.loading('Cargando productos...')
      vm.productSelectList().then(() => {
        vm.products = vm.$store.getters['product/getProducts']
        loading.hide()
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      })
    },
    getBusinessTypes($event) {
      const vm = this
      vm.selectedKpiAdherencia = null
      vm.registroAdherencia = 0
      const loading = vm.$toast.loading('Cargando kpis de negocio...')
      vm.businessBySegTraProd({
        segment: vm.openSelected ? vm.selectedRole.triplets[0].segment : vm.selectedSegmento._id, 
        travel: vm.openSelected ? vm.selectedRole.triplets[0].travel : vm.selectedViaje._id,
        product: vm.openSelected ? vm.selectedRole.triplets[0].product : vm.selectedProducto._id 
      }).then(() => {
        vm.businesstypes = vm.$store.getters['businesstype/getBusinessType']
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      })
      loading.hide()
    },
    getKpisByIds($event) {
      const vm = this
      const loading = vm.$toast.loading('Cargando kpis de adherencia...')
      vm.byTriplets({
        travel: vm.openSelected ? vm.selectedRole.triplets[0].travel : vm.selectedViaje._id, 
        segment: vm.openSelected ? vm.selectedRole.triplets[0].segment : vm.selectedSegmento._id, 
        product: vm.openSelected ? vm.selectedRole.triplets[0].product : vm.selectedProducto._id
      }).then((roles) => {
        //filtrar por role de usuarios.
        let rolesFiltered = []
        let rolesForFilter = vm.selectedRole ? [vm.selectedRole._id] : vm.user.role
        if (roles.length > 0) { 
          for (let r of roles) {
            for (let ur of rolesForFilter) {
              if (r._id.toString() == ur) {
                rolesFiltered.push(r)
              }
            }
          }
        }
        if (rolesFiltered.length > 0) {
          vm.kpiByIds({ role: rolesFiltered }).then(() => {
            vm.kpis = vm.$store.getters['kpi/getKpis']
          }, (error) => {
            vm.$notify({
              type: 'danger',
              title: 'Notificación',
              content: error,
              closeable: true,
              duration: 5000
            })
          })
        } else {
          vm.kpis = []
        }
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error,
          closeable: true,
          duration: 5000
        })
      })
      loading.hide()
    },
    remove(id) {
      const vm = this
      vm.deleteObjective(id).then(() => {
        for (let index in vm.currentWeekObjectives) {
          for (let indexo in vm.currentWeekObjectives[index].objectives) {
            if (vm.currentWeekObjectives[index].objectives[indexo]._id == id) {
              vm.currentWeekObjectives[index].objectives.splice(indexo, 1)
            }
          }
          if (vm.currentWeekObjectives[index].objectives.length == 0) {
            vm.currentWeekObjectives.splice(index, 1)
          }                  
        }        
        vm.$notify({
          type: 'success',
          title: 'Notificación',
          content: 'Objetivo eliminado',
          closeable: true,
          duration: 5000
        })
      })
    },
    openObjDetail(id) {
      const vm = this              
      vm.getObjectiveById(id).then(() => {        
        vm.objective = vm.$store.getters['objective/getObjective']        
        vm.drawer2 = !vm.drawer2
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    _clearForm() {
      const vm = this
      vm.selectedRole = null
      vm.selectedViaje = null
      vm.selectedSegmento = null
      vm.selectedProducto = null
      vm.selectedKpiNegocio = null
      vm.selectedKpiAdherencia = null
      vm.users = []
      vm.openSelected = false
      vm.comment = null
      vm.date_opobj = null
    },
    _addNewObject(obj, cIndex = null) {
      const vm = this
      const objectivesToUpdate = new Array()
      let updateBiz = false
      var currentWeekIndex = null
      
      if (vm.currentWeekObjectives.length > 0) {        
        let addnew = true
        for (let index in vm.currentWeekObjectives) {
          if (obj.open) {
            if (vm.currentWeekObjectives[index]._id.business_type[0].name == obj.business_type[0].name) {
              vm.currentWeekObjectives[index].objectives.forEach(objective => {
                objectivesToUpdate.push(objective._id)
              })
              currentWeekIndex = index
              updateBiz = true
              if (vm.continuedObjectives.length > 0) {
                if (+vm.continuedObjectives[cIndex].objectives[0].businesspercentage !== +obj.businesspercentage) {
                  vm.continuedObjectives[cIndex].objectives.forEach(objective => {
                    objectivesToUpdate.push(objective._id)
                  })
                }
              }
              addnew = false
              vm.currentWeekObjectives[index].objectives.push(obj)
            }
          } else if (vm.currentWeekObjectives[index]._id.travel.length > 0) {
            if (vm.currentWeekObjectives[index]._id.travel.name == obj.travel.name && vm.currentWeekObjectives[index]._id.product.name == obj.product.name && vm.currentWeekObjectives[index]._id.segment.name == obj.segment.name && vm.currentWeekObjectives[index]._id.business_type[0].name == obj.business_type[0].name) {
              vm.currentWeekObjectives[index].objectives.forEach(objective => {
                objectivesToUpdate.push(objective._id)
              })
              currentWeekIndex = index
              updateBiz = true
              if (vm.continuedObjectives.length > 0) {
                if (+vm.continuedObjectives[cIndex].objectives[0].businesspercentage !== +obj.businesspercentage) {
                  vm.continuedObjectives[cIndex].objectives.forEach(objective => {
                    objectivesToUpdate.push(objective._id)
                  })
                }
              }
              addnew = false
              vm.currentWeekObjectives[index].objectives.push(obj)
            }
          }
        }
        
        if (addnew) {
          vm.currentWeekObjectives.push({
            _id: {travel: obj.travel ? [obj.travel] : [], product: obj.product ? [obj.product] : [], segment: obj.segment ? [obj.segment] : [],business_type: [obj.business_type[0]]},
            objectives: [obj]
          })
        }
      } else {
        if (cIndex != null) {
          if (+vm.continuedObjectives[cIndex].objectives[0].businesspercentage !== +obj.businesspercentage) {
            vm.continuedObjectives[cIndex].objectives.forEach(objective => {
              objectivesToUpdate.push(objective._id)
            })
          }
          updateBiz = true
        }
        
        vm.currentWeekObjectives.push({
          _id: {travel: obj.travel ? [obj.travel] : [], product: obj.product ? [obj.product] : [], segment: obj.segment ? [obj.segment] : [], business_type: [obj.business_type[0]]},
          objectives: [obj]
        })
      }
      if (updateBiz) {
        if (currentWeekIndex != null) {
          vm.updateBusiness({ids: objectivesToUpdate, business_percentage: vm.registroNegocio})
          .then(() =>  {
            vm.currentWeekObjectives[currentWeekIndex].objectives[0].businesspercentage = obj.businesspercentage
            if (cIndex) {
              vm.continuedObjectives[cIndex].objectives[0].businesspercentage = obj.businesspercentage
            } 
          }).catch(error => console.log(error))
        } else {
          vm.updateBusiness({ids: objectivesToUpdate, business_percentage: vm.registroNegocio})
          .then(() => {
            vm.continuedObjectives[cIndex].objectives[0].businesspercentage = obj.businesspercentage
          })
        }
      } 
    },
    setPorcentage() {
      const vm = this;
      vm.continuedObjectives.forEach(continued => {
        if (continued._id.travel.length == 0 && continued._id.product.length == 0 && continued._id.segment.length == 0 && selectedKpiNegocio.name == continued.business_type[0].name) {
          vm.registroNegocio = continued.objectives[0].businesspercentage
        } else if (vm.selectedSegmento.name === continued._id.segment[0].name && vm.selectedProducto.name === continued._id.product[0].name && vm.selectedViaje.name === continued._id.travel[0].name && vm.selectedKpiNegocio.name === continued._id.business_type[0].name) {
          vm.registroNegocio = continued.objectives[0].businesspercentage
        }
      })

      vm.currentWeekObjectives.forEach(currentWeek => {
        if (currentWeek._id.travel.length == 0 && currentWeek._id.product.length == 0 && currentWeek._id.segment.length == 0 && selectedKpiNegocio.name == currentWeek.business_type[0].name) {
          vm.registroNegocio = continued.objectives[0].businesspercentage
        } else if (vm.selectedSegmento.name === currentWeek._id.segment[0].name && vm.selectedProducto.name === currentWeek._id.product[0].name && vm.selectedViaje.name === currentWeek._id.travel[0].name && vm.selectedKpiNegocio.name === currentWeek._id.business_type[0].name) {
          vm.registroNegocio = currentWeek.objectives[0].businesspercentage
        }
      })
    },
    getUserRoles() {
      const vm = this;
      vm.roleByIds({ids: vm.user.role}).then(() => {
        vm.userRoles = vm.$store.getters['role/getRoles']
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    _countObjectives() {
      let vm = this
      let co = 0
      let cwo = 0
      if (vm.continuedObjectives.length > 0) {
        for (let o of vm.continuedObjectives) {
          if (o.objectives.length > 0) {
            co += o.objectives.length
          }
        }
      }
      if (vm.currentWeekObjectives.length > 0) {
        for (let o of vm.currentWeekObjectives) {
          if (o.objectives.length > 0) {
            cwo += o.objectives.length
          }
        }
      }
      
      return co + cwo
    },
    getSelectedTriplets($event) {
      const vm = this
      if (!vm.openSelected) {
        vm.selectedViaje = vm.selectedRole.triplets[0].travel
        vm.selectedSegmento = vm.selectedRole.triplets[0].segment
        vm.selectedProducto = vm.selectedRole.triplets[0].product
      } else {
        vm.selectedViaje = null
        vm.selectedSegmento = null
        vm.selectedProducto = null
      }
      vm.getKpisByIds()
      vm.getBusinessTypes()
    },
    validateForm() {
      const vm = this;
      let isValid = true;

      if (!vm.openSelected) {
        if ( vm.selectedViaje === null || vm.selectedSegmento === null || vm.selectedProducto === null || vm.selectedKpiNegocio === null|| vm.selectedKpiAdherencia === null || vm.registroNegocio === null || vm.registroAdherencia === null) {
          isValid = false;
        }
      } else {
        if ( vm.selectedKpiNegocio === null|| vm.registroNegocio === null || vm.openSelected == null) {
          isValid = false;
        }
      }

      return isValid;
    },
    OpenEditCommObj(objective_id, comment_id, comm_text) {
      const vm = this;
      vm.$bvModal.show(vm.editCommModal.id)
      vm.commentObjectiveEdit = comm_text;
      vm.editCommModal.objective_id = objective_id;
      vm.editCommModal.comment_id = comment_id;
    },
    editCommentObjective() {
      const vm = this;
      let data = {
        id:  vm.editCommModal.objective_id,
        comment_id: vm.editCommModal.comment_id,
        text: vm.commentObjectiveEdit
      }
      vm.updateObjectComment(data).then((objective) => {
        vm.objective = objective;
        vm.$bvModal.hide(vm.editCommModal.id);
        vm.drawer2 = !vm.drawer2
      }, (error) => {
        vm.$bvModal.hide(vm.editCommModal.id);
        vm.drawer2 = !vm.drawer2
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      });
    },
    closeCommentUpdate() {
      const vm = this;
      vm.$bvModal.hide(vm.editCommModal.id);
      vm.drawer2 = !vm.drawer2
    }
  },
  watch: {
      moveobjetivo: function(){
        let moveobjetivo = this.moveobjetivo
        if(this.moveobjetivo === true) {
            this.$emit('can-continue', {value: true});
            this.$emit('completed-step', {value: true});
        } else {
            this.$emit('can-continue', {value: false});
        }
      },
      currentWeekObjectives: function() {
        const vm = this
        if (vm.currentWeekObjectives.length > 0) {
          this.$emit('can-continue', {value: true});
          // this.$emit('completed-step', {value: true});
        }
      },
      continuedObjectives: function() {
        const vm = this
        if (vm.continuedObjectives.length > 0) {
          this.$emit('can-continue', {value: true});
          // this.$emit('completed-step', {value: true});
        }
      },
      currentStep: function(){
        const vm = this
        if(vm.continuedObjectives.length || vm.currentWeekObjectives.length > 0) {
            vm.$emit('can-continue', {value: true});
        } else {
            vm.$emit('can-continue', {value: false});
        }
      }       
  },
  mounted() {
    const vm = this
    const loading = vm.$toast.loading('Cargando...')
    vm.team = vm.$store.getters['user/getMyTeam']
    vm.user = vm.$store.getters['auth/getUserInfo']
    vm.travels = vm.$store.getters['travel/getTravels']
    vm.plan = vm.$store.getters['plan/getPlan']
    vm.getContObjByPlan({id: vm.plan._id, continued: false, user: vm.user.id}).then(() => {
      vm.currentWeekObjectives = vm.$store.getters['objective/getObjectives']
      vm.getContObjByPlan({id: vm.plan._id, continued: true, user: vm.user.id}).then(() => {
        vm.continuedObjectives = vm.$store.getters['objective/getObjectives']
        vm.getUserRoles()
        vm.getSegments()
        vm.getProducts()
        if(vm.continuedObjectives.length || vm.currentWeekObjectives.length > 0) {
            vm.$emit('can-continue', {value: true});
        } else {
            vm.$emit('can-continue', {value: false});
        }
        loading.hide()      
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    }, (error) => {
      loading.hide()
      vm.$notify({
        type: 'danger',
        title: 'Notificación',
        content: error.payload.message,
        closeable: true,
        duration: 5000
      })
    })    
  },
   computed: {
    states () {      
      if (!this.selectedViaje) {
        return
      }
      return this.viajes[this.selectedViaje].map(viaje => {
        return viaje.viajeState
      })      
    }
  }
};


</script>

<style lang="stylus">
</style>


// WEBPACK FOOTER //
// src/views/ps-objetivos-ge.vue